import { createContext, useContext } from 'react'

export type AppContextProps = {
  /** Auth0 JWT token for the user. */
  jwtToken: () => Promise<string>
  /** True if the current user is a super admin */
  isSuperAdmin?: boolean
}

/** App context. */
const AppContext = createContext<AppContextProps>({
  jwtToken: () => Promise.resolve(''),
  isSuperAdmin: false,
})

export const useAppContext = () => useContext(AppContext)

export default AppContext
